import { IS_KASIA_GROUP, IS_STAGING } from "@/config";

// School year 2026/2027
export const AUTOMARK_DEFAULT_START_DATE =
  IS_KASIA_GROUP || IS_STAGING ? "2026-07-01" : "2026-09-01";

export const AUTOMARK_DEFAULT_END_DATE = "2027-06-26";
